/* eslint-disable no-script-url */

import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { Tabs, Tab, Box } from '@material-ui/core'

const TabPanel: React.FC<{
  children?: React.ReactNode
  index: number
  value: number
}> = props => {
  const { children, value, index } = props
  return <Box display={value === index ? 'block' : 'none'}>{children}</Box>
}

const useStyles = makeStyles(theme => ({
  defaultTab: {}
}))

const DefaultTab: React.FC<{
  tabs: { value: number; label: string; component: React.ReactNode }[]
  initTab?: number
}> = ({ tabs, initTab = 1 }) => {
  const classes = useStyles({})
  const [currentTab, setCurrentTab] = useState<number>(1)

  useEffect(() => {
    setCurrentTab(initTab)
  }, [initTab])

  return (
    <React.Fragment>
      <Tabs
        className={classes.defaultTab}
        variant="fullWidth"
        value={currentTab}
        onChange={(event: React.ChangeEvent<{}>, value: any) => {
          setCurrentTab(value)
        }}
      >
        {tabs.map(tab => (
          <Tab key={tab.value} value={tab.value} label={tab.label} wrapped />
        ))}
      </Tabs>
      <Box p={3}>
        {tabs.map(tab => (
          <TabPanel key={`tabpanel-${tab.value}`} value={currentTab} index={tab.value}>
            {tab.component}
          </TabPanel>
        ))}
      </Box>
    </React.Fragment>
  )
}

export default DefaultTab
